export const WORKBENCH_TABSETS = { dataSources: ['connections', 'agents'] };
